import { Box, Paper, Stack } from '@mui/material';
import Logo from './SvgNatomaLogo';

export default function HomeViewPaper({
  children
}: {
  children: React.ReactNode;
}) {
  return (
    <Stack alignItems="center">
      <Box textAlign="center" sx={{ marginBottom: 3 }}>
        <Logo />
      </Box>
      <Paper
        elevation={4}
        sx={(theme) => ({
          maxWidth: '500px',
          padding: theme.spacing(4),
          background: theme.palette.background.paper,
          borderRadius: theme.spacing(4),
          borderColor:
            theme.palette.mode === 'dark'
              ? theme.palette.grey[200]
              : theme.palette.background.paper,
          borderStyle: 'solid',
          borderWidth: 1,
          width: '100%'
        })}
      >
        {children}
      </Paper>
    </Stack>
  );
}
